import {
  Component,
  Event,
  EventEmitter,
  Host,
  Listen,
  State,
  h,
} from '@stencil/core';
import { Unsubscribe, store } from '@stencil/redux';
import { OobChallenge, OobResponseInfo } from '../../class/class';
import { Language, NotificationType } from '../../enums/const-enums';
import {
  clearNotification,
  showNotification,
} from '../../redux/actions/notification-action';
import { RootState, initialStore } from '../../redux/store';
import { SignSubmit } from '../../service/sign-submit';
import { focusSignElement, handleErrorResponse } from '../../utils/utils';
import { RassOobTranslations, rassOobTranslations } from './i18n/rass-oob.i18n';

@Component({
  tag: 'rass-oob',
  styleUrl: 'rass-oob.scss',
  shadow: false,
})
export class RassOob {
  @State() assetsPath: string;
  @State() language: Language;
  @State() challengeData: OobChallenge;
  @State() isSubmitRequestPending = false;
  @Event({ eventName: 'code:reset' }) resetCodeEvent: EventEmitter;
  showNotification!: typeof showNotification;
  clearNotification!: typeof clearNotification;
  unsubscribe!: Unsubscribe;

  componentWillLoad(): void {
    store.setStore(initialStore);
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      const {
        config: { assetsPath, language },
        challengeData,
      } = state;
      return { assetsPath, language, challengeData };
    });
    store.mapDispatchToProps(this, {
      showNotification,
      clearNotification,
    });
    this.clearNotification();
  }

  componentDidLoad(): void {
    focusSignElement('sign_code input', { preventScroll: true });
  }

  componentWillRender(): void {
    this.showNotification({
      type: NotificationType.WARNING,
      header: '',
      body:
        this.translations.notifications.intro_1 +
        this.challengeData.phone_number +
        this.translations.notifications.intro_2 +
        this.phoneNumberHelpDesk,
    });
  }

  @Listen('rass:code:submit')
  submitConfirmationCode(event: CustomEvent<string>): void {
    this.isSubmitRequestPending = true;
    const responseInfo = new OobResponseInfo(event.detail);
    new SignSubmit()
      .doSignSubmit(responseInfo)
      .catch((error: AppModel.HttpResponseErrorJson) => {
        handleErrorResponse(error);
        this.isSubmitRequestPending = false;
        this.resetCodeEvent.emit();
        focusSignElement('sign_code input');
      });
  }

  get phoneNumberHelpDesk(): string {
    switch (this.challengeData.helpdesk_ref) {
      //for me it's R, are these still up to date?
      case 'RN':
        return this.translations.notifications.help_desk.phone_helpdesk_rn;
      case 'FL':
        return this.translations.notifications.help_desk.phone_helpdesk_fl;
      case 'PRO':
        return this.translations.notifications.help_desk.phone_helpdesk_pro;
      default:
        return this.translations.notifications.help_desk.phone_helpdesk_none;
    }
  }

  get translations(): RassOobTranslations {
    return (
      rassOobTranslations[this.language] || rassOobTranslations[Language.EN]
    );
  }

  render(): void {
    return (
      <Host class="section-oob">
        <style>@import url({`'${this.assetsPath}css/sfc-style.css'`});</style>
        <div class="sfc-container body-width" role="form">
          <rass-code-submit is-disabled={this.isSubmitRequestPending} />
        </div>
      </Host>
    ) as void;
  }
}
